// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found-page_wrapper__4BPvK","title":"not-found-page_title__-iMo0","img":"not-found-page_img__FCWXm"};